import { UserMessage } from "@bt-common/schemas/bt/user-message";
import { DBThunkHooks } from "../DBServiceReducersInterfaces";

/**
 * #270 — a lean (paged) row has `linkPreview.thumbnail` projected out and `hasThumbnail: true`.
 * The backend's #269 contract for an omitted thumbnail is `linkPreview.thumbnailOmitted: true`:
 * the edit dialog round-trips the linkPreview object and the backend's restoreOmittedThumbnail puts
 * the stored thumbnail back on patch/update. Without that marker, saving a lean row would WIPE the
 * stored thumbnail. So every lean row is stamped with the same marker the large-result path uses.
 */
type LeanLinkPreview = { thumbnail?: unknown; thumbnailOmitted?: boolean };

export const markLeanThumbnail = (row: UserMessage): UserMessage => {
    const lean = row as UserMessage & { hasThumbnail?: boolean };
    if (lean.hasThumbnail !== true) return row;
    const preview = row.linkPreview as LeanLinkPreview | null | undefined;
    if (!preview || preview.thumbnail || preview.thumbnailOmitted === true) return row;
    return { ...row, linkPreview: { ...preview, thumbnailOmitted: true } } as UserMessage;
};

export const UserMessageHooks: DBThunkHooks<UserMessage> = {
    after: {
        find: (rows: UserMessage[]) => rows.map(markLeanThumbnail),
    },
};
